import {useEffect,useMemo,useState} from 'react';
import {liveQuery} from 'dexie';
import {db,workspaceAccount,normalizeWorkspaceAccount} from './db';

export const defaultPersonalSettings = {
  name:'', bio:'', picture:'',
  locationEnabled:true, followLocation:true, showZoomControls:false,
  layers:{'Live users':true,'Farm Boundary':true,'Tracts':true,'Fields':true,'Structures':true,'Blinds':true,'Tree Stands':true,'Other Places':true,'Trails & Roads':true,'Other Features':true,'Inactive POIs':false} as Record<string,boolean>,
};
export type PersonalSettings=typeof defaultPersonalSettings;
export function usePersonalSettings(account?:string,roles:readonly string[]=[]) {
  const isHunter=roles.includes('Hunter');
  const defaults=useMemo(()=>({...defaultPersonalSettings,layers:{...defaultPersonalSettings.layers,'Inactive POIs':isHunter}}),[isHunter]);
  const [settings,setSettings]=useState<PersonalSettings>(defaults);
  const [ready,setReady]=useState(false);
  useEffect(()=>{const database=db;setSettings(defaults);setReady(false);
    const subscription=liveQuery(()=>database.workspaceMeta.get('personal-settings')).subscribe({next:row=>{
      if(database!==db)return;
      let legacyEnabled=true;
      try{legacyEnabled=localStorage.getItem(`gps:enabled:${account||'anonymous'}`)!=='false';}catch{}
      const {shareLocation: _retiredSharingChoice,...saved}=row?.value||{};
      setSettings({...defaults,locationEnabled:legacyEnabled,...saved,layers:{...defaults.layers,...row?.value?.layers}});setReady(true);
    }});return()=>subscription.unsubscribe();
  },[account,defaults]);
  const save=async(patch:Partial<PersonalSettings>)=>{
    const database=db;
    if(normalizeWorkspaceAccount(account||null)!==workspaceAccount)throw new Error('Account changed. Reopen preferences.');
    await database.transaction('rw',database.workspaceMeta,async()=>{
      if(database!==db)throw new Error('Account changed. Reopen your preferences.');
      const row=await database.workspaceMeta.get('personal-settings');
      // Persist explicit layer choices, so unrelated saves do not freeze role defaults.
      const {shareLocation: _retiredSharingChoice,...saved}={...settings,...row?.value,...patch};
      await database.workspaceMeta.put({key:'personal-settings',value:{...saved,layers:{...row?.value?.layers,...patch.layers}}});
    });
  };
  return {settings,save,ready};
}
